import { useTranslation } from 'react-i18next';
import { Tooltip } from 'antd';
import React from 'react';

import "./FishboneBody.sass";

export const FishboneBody = (props: any) => {

	const { t } = useTranslation();

	return (

		<g className="FishboneBody">
			<g transform={'translate(' + props.leftOffset + ')'}>

				<g className="FishboneBody LineGroup">
					<line
						strokeWidth={25}
						x1={0}
						x2={props.width}
						y1={props.height / 2}
						y2={props.height / 2}
						stroke="#FFFFFF00"
						className="wrapper"
						pointerEvents="none"
					></line>

					<line
						strokeWidth={2}
						x1={0}
						x2={props.width}
						y1={props.height / 2}
						y2={props.height / 2}
						stroke="#A6B9C8"
						className="main"
						pointerEvents="none"
					></line>
				</g>

				{props.children.map((c: React.ReactElement, index: number) => {
					let chunkSize = props.children.length <= 2 ? (props.width * 0.85) / props.children.length : (props.width * 2 * 0.85) / props.children.length;

					return React.cloneElement(c, {
						// 1ère branche (index 0) en HAUT à gauche (plus clair). Pierre.
						position: index % 2 ? 'bottom' : 'top',
						odd: index % 4 == 1 || index % 4 == 2,
						width: chunkSize * 0.8,
						height: props.height / 2,
						leftOffset: (index / 2) * chunkSize - 0.05 * chunkSize,
						topOffset: index % 2 ? props.height / 2 : 0,
						debug: false
					});
				})}
				{props.onCreateBranch && <Tooltip title={t('models.fishbone_branch.actions.add')}>
					<g
						className="add"
						data-testid="add-branch-button"
						onClick={() => {
							if (props.onCreateBranch) props.onCreateBranch();
						}}
						style={{ cursor: 'pointer' }}
						transform={
							'translate(' +
							(props.width * 0.05) +
							' ' +
							props.height / 2 +
							')'
						}
					>
						<circle r={15} fill={'#CCCCCC'}></circle>
						<text fontSize={36} dx={-10} dy={13} style={{ pointerEvents: 'none' }}>
							+
						</text>
					</g>
				</Tooltip>}
			</g>
		</g>
	);
};
